import Choices from 'choices.js'
import UtmCookies from './utmCookies'

export default class JobForm {
    constructor () {
        this.form = document.querySelector('[data-job-embedded-form]')
        if (!this.form) return
        this.setup(this.form)
    }

    setup (form) {
        form.addEventListener('submit', this.submit.bind(this))
        form.querySelector('[data-resume-file]')?.addEventListener('change', this.fileChange.bind(this))

        this.successRedirect = form.dataset.successRedirect === 'true'
        this.formToggleEl = form.parentNode.querySelector('[data-form-toggle]')
        this.formToggleEl?.addEventListener('click', this.showForm.bind(this))
        form.parentNode.querySelector('[data-form-title]')?.addEventListener('click', this.showForm.bind(this))
        form.querySelector('[data-form-btn]')?.addEventListener('click', this.addSubbmitedFlag.bind(this))

        this.fileNameEl = form.querySelector('[data-resume-file-name]')
        this.fileNameDefault = this.fileNameEl.innerHTML

        this.sourceField = form.querySelector('[data-source-field]')
        if (this.sourceField)
            this.updateSource()

        this.residence = form.querySelector('[data-state-residence]')
        if (this.residence) {
            const statesEl = this.residence

            // eslint-disable-next-line no-new
            new Choices(this.residence, {
                placeholder: true,
                callbackOnInit () {
                    const input = statesEl.closest('.choices').querySelector('select')
                    statesEl.addEventListener('invalid', () => input.setCustomValidity(statesEl.validationMessage))
                    statesEl.addEventListener('change', () => input.setCustomValidity(statesEl.validationMessage))
                }
            })
        }

        this.toggleResumeRequired()

        // Enable recaptcha
        this.recaptchaSiteKey = form.dataset.recaptchaSiteKey
        this.recaptchaField = form.querySelector('[data-recaptcha-field]')

        if (this.recaptchaSiteKey && this.recaptchaField)
            document.addEventListener('DOMContentLoaded', () => {
                window.grecaptcha.ready(() => {
                    this.updateRecaptcha()

                    setInterval(() => {
                        this.updateRecaptcha()
                    }, 1000 * 60 * 1.9) // expires after 2 minutes
                })
            })
    }

    updateRecaptcha () {
        window.grecaptcha.execute(this.recaptchaSiteKey, { action: 'submit' }).then((token) => {
            this.recaptchaField.value = token
        })
    }

    toggleResumeRequired () {
        const resumeRequiredEl = this.form.querySelector('[data-resume-file-required]')
        if (resumeRequiredEl) {
            const resumeRequiredStyle = window.getComputedStyle(resumeRequiredEl)
            const resumeRequiredVisible = resumeRequiredStyle.getPropertyValue('display') !== 'none'

            if (!resumeRequiredVisible)
                this.form.querySelector('[data-resume-file]').required = false
        }
    }

    addSubbmitedFlag () {
        this.form.parentNode.classList.add('submitted')
    }

    showForm (e) {
        this.formToggleEl.classList.add('d-none')
        this.form.classList.remove('d-none')
    }

    updateSource () {
        const urlParams = new URLSearchParams(window.location.search)
        const utmSource = urlParams.get('utm_source')

        if (utmSource)
            this.sourceField.value = utmSource
        else {
            const cokkieSource = UtmCookies.getParamFromCookies('utm_source')
            if (cokkieSource)
                this.sourceField.value = cokkieSource
        }
    }

    fileChange (event) {
        const file = event.target.files[0]

        if (!file) {
            this.fileContent = null
            this.fileNameEl.innerHTML = this.fileNameDefault
            return
        }

        // eslint-disable-next-line no-undef
        const reader = new FileReader()
        reader.readAsDataURL(file)

        reader.onload = () => {
            const fileContent = reader.result.split(',')[1]
            this.fileContent = fileContent
            this.fileName = file.name
            this.fileNameEl.innerHTML = this.fileName
        }
    }

    submit (e) {
        e.preventDefault()

        const form = e.target
        const formError = form.querySelector('[data-form-error]')
        const submitBtn = form.querySelector('[data-form-btn]')
        const formWrap = form.parentNode

        formError.classList.add('d-none')
        submitBtn.classList.add('btn--loading')

        // eslint-disable-next-line no-undef
        const formData = new FormData(form)

        fetch('/wp-json/fountain/v1/submit-application', {
            method: 'POST',
            body: formData
        })
            .then(response => {
                if (!response.ok)
                    throw new Error(response.statusText)
                return response.json()
            })
            .then(data => {
                if (window.dataLayer) {
                    // eslint-disable-next-line no-undef
                    dataLayer.push({
                        event: 'smartrecruiter_form_submission'
                    })

                    // eslint-disable-next-line no-undef
                    dataLayer.push({
                        event: 'job_form_submission',
                        submissionValues: Object.fromEntries(formData)
                    })
                }

                if (this.successRedirect)
                    window.location.href = data.url
                else {
                    submitBtn.classList.remove('btn--loading')
                    formWrap.classList.add('success')
                    window.scrollTo(0, 0)
                }
            })
            .catch(error => {
                formError.classList.remove('d-none')
                submitBtn.classList.remove('btn--loading')
                console.error(error)
                this.updateRecaptcha() // reset recaptcha
            })
    }
}
